module.exports = __webpack_public_path__ + "assets/img/word-yes.07831155.png";